
import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getRoomsStates = async () => {
  return await request.get(
    `/RentPlace/office/status`,
    {},
    'При загрузке статусов офисов произошла ошибка',
    []
  );
};

const useRoomsStates = (options) =>
  useQuery([queries.officesStates], () => getRoomsStates(), {
    placeholderData: [],
    ...options
  });

export default useRoomsStates;
